import { render, staticRenderFns } from "./permanen.vue?vue&type=template&id=a303fab0&scoped=true"
import script from "./permanen.vue?vue&type=script&lang=js"
export * from "./permanen.vue?vue&type=script&lang=js"
import style0 from "./permanen.vue?vue&type=style&index=0&id=a303fab0&prod&lang=scss"
import style1 from "./permanen.vue?vue&type=style&index=1&id=a303fab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a303fab0",
  null
  
)

export default component.exports